import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { useChatWidgetContext } from '@/widget/services/useChatWidgetContext';
import { useStore } from 'zustand';
import ContactDispatcher from '@/widget/application/contact/ContactDispatcher';

const fieldValidation = {
  first_name: {
    required: {
      value: true,
      message: 'required',
    },
  },
  last_name: {
    required: {
      value: true,
      message: 'required',
    },
  },
  phone: {
    required: {
      value: true,
      message: 'required',
    },
    pattern: {
      value: /^(\+*)(\d*)([(]\d{1,3}[)]*)*(\s?\d+|\+\d{2,3}\s\d+|\d+)[\s|-]?\d+([\s|-]?\d+){1,2}(\s)*$/gm,
      message: 'wrong_format',
    },
  },
  email: {
    required: {
      value: true,
      message: 'required',
    },
    pattern: {
      value: /\S+@\S+\.\S+/,
      message: 'wrong_format',
    },
  },
};

const fieldPlaceholder = {
  email: 'test@test.com',
  phone: '+1 234 56 78 90',
};

export default function useContactForm() {
  const { store, settings } = useChatWidgetContext();
  const {
    formFields,
    privatePolicyUrl,
  } = settings;
  const activeConversationKey = useStore(store, (state) => state.activeConversationKey);
  const subscription = useStore(store, (state) => state.widgetSubscription);
  const [sending, setSending] = useState(false);
  const {
    setFocus, handleSubmit, register, getValues, formState: { errors },
  } = useForm({ reValidateMode: 'onChange' });
  const [fields, setFields] = useState(
    formFields.map((f) => ({
      name: f,
      active: false,
      props: register(f, { ...fieldValidation[f] }),
    })),
  );

  const handleFocus = (fieldName = '') => {
    setFields((prevState) => (
      prevState.map((field) => ({
        ...field,
        active: field.name === fieldName,
      }))
    ));
  };

  const onSubmit = (data) => {
    setSending(true);
    ContactDispatcher.sendContactForm({
      conversationKey: activeConversationKey,
      formData: data,
      subscription,
    });
    setSending(false);
  };

  return {
    sending,
    fields,
    errors,
    getValues,
    fieldPlaceholder,
    privatePolicyUrl,
    setFocus,
    handleFocus,
    handleSubmit,
    onSubmit,
  };
}
